import { render, staticRenderFns } from "./orderItem1.vue?vue&type=template&id=0ba09cce"
import script from "./orderItem1.vue?vue&type=script&lang=js"
export * from "./orderItem1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports